export const events = [
  {
    id: "evt-001",
    title: "甲级联赛焦点战：蓝港城主场迎战铁砧竞技",
    categoryId: "football",
    date: "2026-10-12",
    time: "19:30",
    location: "蓝港城体育中心",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20football%20stadium%20at%20night%20under%20bright%20floodlights%2C%20green%20pitch%20with%20white%20line%20markings%2C%20dramatic%20moody%20deep%20blue%20and%20orange%20lighting%2C%20cinematic%20sports%20photography%20with%20strong%20contrast%20and%20stylized%20atmosphere&width=1600&height=900&seq=evt-football-01&orientation=landscape",
    summary:
      "蓝港城凭借下半场的换人调整完成逆转，铁砧竞技则在最后二十分钟连续丢掉中场控制权，防线问题再度暴露。",
    tags: ["足球", "甲级联赛", "焦点战"],
    views: 18420,
    status: "ended",
    score: "2 : 1",
    highlight:
      "蓝港城在下半场第 63 分钟由替补前锋打破僵局，随后第 78 分钟再下一城锁定胜局；铁砧竞技仅在第 88 分钟扳回一球。",
    teams: [
      {
        name: "蓝港城",
        short: "蓝港",
        recent: "近 5 场 3 胜 1 平 1 负",
        rank: 4,
        note: "主场作战压制力强，定位球战术执行到位，中场轮换深度充足。",
        form: ["W", "W", "D", "L", "W"],
      },
      {
        name: "铁砧竞技",
        short: "铁砧",
        recent: "近 5 场 1 胜 1 平 3 负",
        rank: 12,
        note: "客场下半场体能与专注度下滑明显，后防线协防默契不足。",
        form: ["L", "D", "L", "W", "L"],
      },
    ],
    body: [
      "本轮甲级联赛的焦点战在蓝港城体育中心打响。开场阶段双方节奏偏慢，蓝港城通过边路传中不断试探对手禁区，铁砧竞技则以密集防守和快速反击应对，前 45 分钟双方均未取得进球。",
      "易边再战，蓝港城主教练果断换上速度型前锋，直接改变了比赛节奏。第 63 分钟，蓝港城在一次连续传导后由替补前锋完成低射破门；第 78 分钟，球队再利用角球机会由中卫头槌扩大领先优势。铁砧竞技直到第 88 分钟才凭借一次混战扳回一球，但已无力回天。",
      "赛后技术统计显示，蓝港城全场射正 7 次、控球率 58%，铁砧竞技则在下半场传球成功率明显下降。铁砧竞技近期的客场表现持续低迷，后防线协防问题成为其进入今日黑榜的主要原因。",
    ],
  },
  {
    id: "evt-002",
    title: "甲级联赛保级战：雾都联作客挑战白鲸 FC",
    categoryId: "football",
    date: "2026-10-11",
    time: "20:00",
    location: "白鲸湾球场",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20football%20pitch%20in%20light%20rain%20with%20misty%20atmosphere%2C%20stadium%20stands%20blurred%20in%20background%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20moody%20cinematic%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=evt-football-02&orientation=landscape",
    summary:
      "一场关键的保级对话以平局收场，雾都联全场被动但依靠门将神勇发挥守住一分，进攻端效率持续走低。",
    tags: ["足球", "甲级联赛", "保级战"],
    views: 11230,
    status: "ended",
    score: "0 : 0",
    highlight:
      "雾都联门将全场贡献 6 次关键扑救，球队预期进球值仅 0.6，进攻端创下赛季新低。",
    teams: [
      {
        name: "雾都联",
        short: "雾都",
        recent: "近 5 场 0 胜 3 平 2 负",
        rank: 17,
        note: "防守依靠门将支撑，进攻组织混乱，前场球员缺乏有效串联。",
        form: ["D", "L", "D", "D", "L"],
      },
      {
        name: "白鲸 FC",
        short: "白鲸",
        recent: "近 5 场 2 胜 1 平 2 负",
        rank: 14,
        note: "控球占优却得势不得分，最后一传选择偏保守。",
        form: ["W", "L", "W", "D", "L"],
      },
    ],
    body: [
      "白鲸湾球场飘着小雨，湿滑的草皮让双方在传接球上都出现了失误。白鲸 FC 全场控球率达到 64%，多次在边路制造威胁，却始终无法把优势转化为进球。",
      "雾都联在被动局面下依靠门将的连续神扑稳住了阵脚，同时通过零星的反击寻找机会。遗憾的是，球队前场配合缺乏默契，多次快攻都在最后一传时选择失误。",
      "这场平局让雾都联的保级形势依旧严峻，球队进攻效率低下的问题被反复放大，成为进入今日黑榜的重要依据。",
    ],
  },
  {
    id: "evt-003",
    title: "职业篮球联赛：赤焰对阵寒星",
    categoryId: "basketball",
    date: "2026-10-12",
    time: "19:00",
    location: "赤焰体育馆",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20indoor%20basketball%20arena%20with%20polished%20wooden%20court%2C%20spotlights%20and%20crowd%20silhouettes%2C%20deep%20blue%20and%20orange%20lighting%2C%20dramatic%20cinematic%20sports%20photography%2C%20stylized%20high%20contrast&width=1600&height=900&seq=evt-basketball-01&orientation=landscape",
    summary:
      "赤焰末节崩盘被寒星逆转，第四节全队命中率骤降，罚球线上连续失手成为比赛转折点。",
    tags: ["篮球", "职业联赛", "常规赛"],
    views: 15860,
    status: "live",
    score: "88 : 96",
    highlight:
      "赤焰前三节一度领先 12 分，末节单节仅得 14 分，命中率跌至 27%，寒星抓住机会完成反超。",
    teams: [
      {
        name: "赤焰",
        short: "赤焰",
        recent: "近 5 场 2 胜 3 负",
        rank: 8,
        note: "末节执行力不足，关键球处理过于依赖单打。",
        form: ["W", "L", "W", "L", "L"],
      },
      {
        name: "寒星",
        short: "寒星",
        recent: "近 5 场 4 胜 1 负",
        rank: 3,
        note: "防守强度高，第四节轮换阵容储备充足。",
        form: ["W", "W", "L", "W", "W"],
      },
    ],
    body: [
      "赤焰体育馆座无虚席。主队前三节手感火热，一度将领先优势扩大到 12 分，外线三分与内线强攻交替得分。",
      "然而进入第四节，赤焰的进攻突然哑火，全队单节命中率仅有 27%，罚球线上更是连续失手。寒星则抓住每一次反击机会，通过高强度防守逼出多次失误完成反超。",
      "最终赤焰主场惜败。赛后数据表明，球队末节的失误数达到 7 次，关键球处理能力成为其近期黑榜指标落后的核心原因。",
    ],
  },
  {
    id: "evt-004",
    title: "职业篮球联赛：巨鹰主场迎战潮汐",
    categoryId: "basketball",
    date: "2026-10-13",
    time: "20:30",
    location: "巨鹰竞技馆",
    cover:
      "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20fictional%20basketball%20court%20with%20sharp%20geometric%20line%20markings%2C%20dramatic%20spotlight%20from%20above%2C%20cool%20blue%20and%20amber%20accents%2C%20minimal%20stylized%20sports%20photography%2C%20high%20contrast&width=1600&height=900&seq=evt-basketball-02&orientation=landscape",
    summary:
      "巨鹰与潮汐的内线对位将成为看点，双方近期状态接近，赛前预判胜负难料。",
    tags: ["篮球", "职业联赛", "赛前预告"],
    views: 6420,
    status: "upcoming",
    score: "-",
    highlight: "两队近 5 次交手各取 2 胜 1 平，本场内线篮板争夺预计是决定胜负的关键。",
    teams: [
      {
        name: "巨鹰",
        short: "巨鹰",
        recent: "近 5 场 3 胜 2 负",
        rank: 5,
        note: "内线强攻稳定，外线投射起伏较大。",
        form: ["W", "W", "L", "W", "L"],
      },
      {
        name: "潮汐",
        short: "潮汐",
        recent: "近 5 场 3 胜 2 负",
        rank: 6,
        note: "团队配合流畅，替补得分能力突出。",
        form: ["L", "W", "W", "L", "W"],
      },
    ],
    body: [
      "巨鹰竞技馆将在今晚迎来巨鹰与潮汐的对决。两队在积分榜上仅相差一个胜场，本场比赛的结果将直接影响季后赛席位争夺。",
      "赛前分析指出，巨鹰的内线强攻与潮汐的团队传导风格形成鲜明对比，篮板球的争夺预计将成为比赛的胜负手。",
      "目前比赛尚未开始，本页面将在赛前持续更新最新赛程安排与首发名单，请关注后续资讯。",
    ],
  },
  {
    id: "evt-005",
    title: "城市耐力赛第三站：环湖 6 小时竞速",
    categoryId: "racing",
    date: "2026-10-12",
    time: "14:00",
    location: "云栖湖国际赛道",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20race%20track%20with%20sleek%20prototype%20cars%20blurring%20past%2C%20long%20exposure%20light%20trails%2C%20dusky%20blue%20sky%20with%20orange%20sunset%20glow%2C%20dynamic%20cinematic%20motorsport%20photography%2C%20high%20detail&width=1600&height=900&seq=evt-racing-01&orientation=landscape",
    summary:
      "耐力赛第三站事故频发，多支车队因进站策略失误损失大量时间，其中极地车队连续两次超时进站成为最大失分点。",
    tags: ["赛车", "耐力赛", "第三站"],
    views: 9870,
    status: "ended",
    score: "P1 / P9",
    highlight:
      "全场共出现 4 次安全车出动，极地车队因进站沟通失误累计损失超过 90 秒。",
    teams: [
      {
        name: "雷霆车队",
        short: "雷霆",
        recent: "近 3 站 2 次登台",
        rank: 1,
        note: "进站策略精准，车手节奏控制稳定。",
        form: ["W", "W", "D"],
      },
      {
        name: "极地车队",
        short: "极地",
        recent: "近 3 站 0 次登台",
        rank: 10,
        note: "进站沟通混乱，轮胎策略保守导致圈速落后。",
        form: ["L", "L", "L"],
      },
    ],
    body: [
      "云栖湖国际赛道迎来城市耐力赛第三站。六小时的持续竞速对车队的进站策略与车手体能都是极大考验。",
      "比赛中四次安全车出动打乱了多支车队的节奏。极地车队在两次进站中因轮胎准备不及时导致超时，累计损失超过 90 秒，名次一路下滑。雷霆车队则凭借精准的轮胎窗口判断稳居前列。",
      "最终雷霆车队以较大的时间优势完赛，而极地车队的进站与策略问题使其成为本站黑榜的焦点。",
    ],
  },
  {
    id: "evt-006",
    title: "新秀杯方程式：夜战排位赛",
    categoryId: "racing",
    date: "2026-10-14",
    time: "21:00",
    location: "曙光街道赛道",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20night%20street%20racing%20circuit%20glowing%20with%20neon%20and%20floodlights%2C%20sleek%20open%20wheel%20car%20mid%20turn%2C%20deep%20blue%20night%20sky%20with%20orange%20light%20streaks%2C%20cinematic%20stylized%20motorsport%20photography&width=1600&height=900&seq=evt-racing-02&orientation=landscape",
    summary: "排位赛将于周四夜间进行，新秀车手需要在陌生街道赛道快速适应制动点与走线。",
    tags: ["赛车", "新秀杯", "排位赛"],
    views: 4210,
    status: "upcoming",
    score: "-",
    highlight: "街道赛道狭窄且路面起伏，排位赛预计事故率偏高，首圈排位将尤为关键。",
    teams: [
      {
        name: "曙光青训",
        short: "曙光",
        recent: "近 3 站 1 次杆位",
        rank: 5,
        note: "新秀成长速度快，排位单圈能力强。",
        form: ["W", "D", "L"],
      },
      {
        name: "北极星车队",
        short: "北极星",
        recent: "近 3 站稳定进积分区",
        rank: 7,
        note: "节奏稳定但极限圈速一般。",
        form: ["D", "W", "D"],
      },
    ],
    body: [
      "新秀杯方程式本周转战曙光街道赛道，排位赛将在夜间进行。街道赛道以狭窄、颠簸和视野受限著称，对年轻车手的适应能力是巨大考验。",
      "车队数据显示，曙光青训的新秀在模拟器上的单圈表现突出，而北极星车队更擅长长距离正赛节奏。",
      "本场排位赛尚未开始，页面将在赛后第一时间更新成绩与赛况摘要。",
    ],
  },
  {
    id: "evt-007",
    title: "全球冠军赛半决赛：星辰对战幽影",
    categoryId: "esports",
    date: "2026-10-12",
    time: "18:00",
    location: "星环电竞中心",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20esports%20arena%20stage%20with%20huge%20glowing%20screens%2C%20silhouettes%20of%20players%20at%20battle%20stations%2C%20deep%20blue%20and%20orange%20stage%20lighting%2C%20futuristic%20cinematic%20atmosphere%20with%20light%20haze&width=1600&height=900&seq=evt-esports-01&orientation=landscape",
    summary:
      "星辰在半决赛中经验不足，关键局团的决策连续失误，被幽影直落两局淘汰。",
    tags: ["电竞", "全球冠军赛", "半决赛"],
    views: 26340,
    status: "ended",
    score: "0 : 2",
    highlight: "星辰在第二局手握经济领先时强行开团，连续两波团战失利直接葬送比赛。",
    teams: [
      {
        name: "星辰战队",
        short: "星辰",
        recent: "近 5 局 2 胜 3 负",
        rank: 6,
        note: "阵容执行力强但关键局决策冒进，团队沟通存在延迟。",
        form: ["L", "W", "L", "L", "W"],
      },
      {
        name: "幽影战队",
        short: "幽影",
        recent: "近 5 局 4 胜 1 负",
        rank: 1,
        note: "团战运营老练，资源控制与视野布控全面领先。",
        form: ["W", "W", "W", "L", "W"],
      },
    ],
    body: [
      "星环电竞中心座无虚席，全球冠军赛首场半决赛在星辰与幽影之间展开。两支战队风格迥异，星辰以line多变的阵容著称，幽影则擅长通过资源运营积累优势。",
      "首局星辰在前期取得小幅领先，但中期多次视野被反蹲导致节奏被拖入幽影熟悉的运营节奏，最终被翻盘。第二局星辰手握经济领先，却两次强行开团接连失利，直接让出胜势。",
      "最终幽影直落两局晋级决赛。星辰在关键局的决策问题被反复提及，成为进入今日黑榜的主要依据。",
    ],
  },
  {
    id: "evt-008",
    title: "全球冠军赛小组赛：雷霆对阵苍穹",
    categoryId: "esports",
    date: "2026-10-12",
    time: "21:30",
    location: "星环电竞中心",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20esports%20LAN%20competition%20hall%20with%20rows%20of%20gaming%20stations%2C%20cool%20blue%20ambient%20light%20with%20warm%20orange%20accents%2C%20slight%20haze%20and%20bokeh%2C%20stylized%20cinematic%20photography%2C%20high%20detail&width=1600&height=900&seq=evt-esports-02&orientation=landscape",
    summary: "小组赛关键一战，两队在资源点的争夺异常激烈，胜负取决于中后期的地图控制。",
    tags: ["电竞", "全球冠军赛", "小组赛"],
    views: 14220,
    status: "ended",
    score: "1 : 3",
    highlight: "雷霆在地图资源控制上全面落后，多次被苍穹抢先占据关键点位。",
    teams: [
      {
        name: "雷霆战队",
        short: "雷霆",
        recent: "近 5 局 1 胜 4 负",
        rank: 11,
        note: "个人能力不俗但团队配合松散，前期资源取舍混乱。",
        form: ["L", "L", "W", "L", "L"],
      },
      {
        name: "苍穹战队",
        short: "苍穹",
        recent: "近 5 局 3 胜 2 负",
        rank: 4,
        note: "地图理解深刻，中后期节奏控制能力强。",
        form: ["W", "L", "W", "W", "L"],
      },
    ],
    body: [
      "小组赛最后一日，雷霆与苍穹为出线名额展开直接对话。比赛一开始，双方就在地图中央的资源点展开拉锯。",
      "苍穹凭借更成熟的视野布控逐步占据主动，多次抢先在关键点位落位，雷霆则在被动应对中不断丢失资源。",
      "最终苍穹以 3:1 拿下比赛。雷霆前期资源取舍混乱、团队配合松散的问题暴露无遗，成为今日黑榜的重点关注对象。",
    ],
  },
  {
    id: "evt-009",
    title: "中量级卫冕战：雷霆拳馆主赛之夜",
    categoryId: "boxing",
    date: "2026-10-11",
    time: "22:00",
    location: "江城拳击馆",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20boxing%20ring%20under%20a%20single%20harsh%20spotlight%20in%20a%20dark%20arena%2C%20hazy%20atmosphere%2C%20deep%20blue%20shadow%20with%20orange%20rim%20light%2C%20dramatic%20cinematic%20sports%20photography%2C%20high%20contrast&width=1600&height=900&seq=evt-boxing-01&orientation=landscape",
    summary: "卫冕冠军在第三回合被击倒告负，防守漏洞与前手拳动作不到位成为失利主因。",
    tags: ["拳击", "卫冕战", "主赛"],
    views: 12980,
    status: "ended",
    score: "KO 第 3 回合",
    highlight: "挑战者利用对手前手拳空档完成致命一击，卫冕冠军防守反应明显迟缓。",
    teams: [
      {
        name: "雷霆拳馆（卫冕方）",
        short: "雷霆",
        recent: "近 3 场 1 胜 2 负",
        rank: 5,
        note: "前手拳防守动作不到位，抗击打能力受到考验。",
        form: ["L", "W", "L"],
      },
      {
        name: "铁拳俱乐部（挑战方）",
        short: "铁拳",
        recent: "近 3 场 3 胜",
        rank: 1,
        note: "组合拳衔接流畅，节奏压迫性强。",
        form: ["W", "W", "W"],
      },
    ],
    body: [
      "江城拳击馆的主赛之夜座无虚席。卫冕冠军带着主场期待登场，挑战者则以连胜气势迎战。",
      "前两回合双方互有攻守，但卫冕冠军的前手拳防守动作明显不到位。第三回合，挑战者抓住对手收拳的瞬间完成一记重击，裁判随即终止比赛。",
      "这场失利让卫冕冠军的防守短板被彻底放大，成为今日黑榜中拳击项目的代表条目。",
    ],
  },
  {
    id: "evt-010",
    title: "新星挑战赛：雏鹰杯次中量级四强战",
    categoryId: "boxing",
    date: "2026-10-15",
    time: "20:00",
    location: "雏鹰体育公园",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20boxing%20training%20gym%20with%20heavy%20bags%20and%20ropes%2C%20warm%20orange%20light%20against%20deep%20blue%20shadows%2C%20dust%20particles%20in%20air%2C%20moody%20stylized%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=evt-boxing-02&orientation=landscape",
    summary: "四强战即将打响，多位新星拳手将争夺决赛席位，体能与抗击打能力是关键。",
    tags: ["拳击", "新星挑战赛", "四强"],
    views: 3860,
    status: "upcoming",
    score: "-",
    highlight: "四强选手实力接近，赛前普遍预测比赛将进入后半程的体能消耗战。",
    teams: [
      {
        name: "雏鹰青训 A",
        short: "雏鹰A",
        recent: "近 3 场 2 胜 1 负",
        rank: 6,
        note: "步伐灵活，反击速度快。",
        form: ["W", "L", "W"],
      },
      {
        name: "雏鹰青训 B",
        short: "雏鹰B",
        recent: "近 3 场 2 胜 1 负",
        rank: 8,
        note: "力量占优，但节奏控制有待提升。",
        form: ["L", "W", "W"],
      },
    ],
    body: [
      "雏鹰杯次中量级四强战即将在雏鹰体育公园举行。本届赛事涌现出多名极具潜力的新星拳手，四强对位相当接近。",
      "教练组分析认为，四强选手在技术层面差距不大，比赛很可能进入后半程的体能消耗战，谁的抗击打与恢复能力更强，谁就更接近决赛。",
      "本场比赛尚未开始，页面将在赛后更新回合数据与结果。",
    ],
  },
  {
    id: "evt-011",
    title: "城市马拉松公开赛：环城 42 公里挑战",
    categoryId: "other",
    date: "2026-10-12",
    time: "07:00",
    location: "市府广场·环城路线",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20city%20marathon%20with%20crowd%20of%20runners%20on%20a%20wide%20avenue%20at%20dawn%2C%20cool%20blue%20morning%20light%20with%20warm%20orange%20sun%20glow%2C%20stylized%20cinematic%20photography%2C%20high%20detail%20and%20energy&width=1600&height=900&seq=evt-other-01&orientation=landscape",
    summary: "超两万名跑者参与的城市马拉松顺利完赛，赛事组织与补给安排获得普遍好评。",
    tags: ["综合", "马拉松", "公开赛"],
    views: 8340,
    status: "ended",
    score: "完赛 21863 人",
    highlight: "本届赛事共设置 12 个补给点，完赛率 96.4%，创历届新高。",
    teams: [
      {
        name: "领跑者集训队",
        short: "领跑",
        recent: "近 3 站 2 次站上领奖台",
        rank: 1,
        note: "配速控制稳定，后程发力能力强。",
        form: ["W", "W", "D"],
      },
      {
        name: "城市跑团联队",
        short: "跑团",
        recent: "近 3 站稳定完赛",
        rank: 6,
        note: "团队氛围好，但精英选手厚度不足。",
        form: ["D", "W", "D"],
      },
    ],
    body: [
      "清晨七点，环城马拉松在晨曦中鸣枪起跑，超过两万名跑者从市府广场出发，沿环城路线完成 42 公里挑战。",
      "本届赛事在补给与服务上做了明显升级，共设置 12 个补给点并配备医疗跑者，全程完赛率达到 96.4%。",
      "赛事整体组织获得跑者普遍好评，相关安排与成绩已同步更新至本站综合赛事栏目。",
    ],
  },
  {
    id: "evt-012",
    title: "综合体能冠军赛：秋季分站赛",
    categoryId: "other",
    date: "2026-10-16",
    time: "15:00",
    location: "力量工场运动中心",
    cover:
      "https://readdy.ai/api/search-image?query=Fictional%20functional%20fitness%20competition%20hall%20with%20ropes%20and%20weights%2C%20athletes%20in%20motion%20blur%2C%20deep%20blue%20shadows%20with%20orange%20accent%20lighting%2C%20stylized%20cinematic%20sports%20photography%2C%20high%20detail&width=1600&height=900&seq=evt-other-02&orientation=landscape",
    summary: "秋季分站赛将进行力量、耐力与技巧三大项比拼，参赛队伍整体水平较往届提升明显。",
    tags: ["综合", "体能赛", "分站赛"],
    views: 2980,
    status: "upcoming",
    score: "-",
    highlight: "三大项总分制让比赛悬念保留到最后，耐力项很可能成为拉开差距的环节。",
    teams: [
      {
        name: "力量工场队",
        short: "力量",
        recent: "上届分站赛冠军",
        rank: 1,
        note: "力量项优势明显，耐力项是相对短板。",
        form: ["W", "W", "W"],
      },
      {
        name: "铁人联合队",
        short: "铁人",
        recent: "上届分站赛亚军",
        rank: 2,
        note: "各项目均衡，团队协作能力强。",
        form: ["W", "W", "D"],
      },
    ],
    body: [
      "综合体能冠军赛秋季分站赛将在力量工场运动中心举行，赛事涵盖力量、耐力与技巧三大项目，采用总分制排名。",
      "从报名名单看，本届参赛队伍整体水平较往届有明显提升，多支队伍都具备冲击冠军的实力。",
      "赛事尚未开始，页面将在比赛结束后更新完整成绩与赛况摘要。",
    ],
  },
];